export default __webpack_public_path__ + "static/media/LENS_CULINARIS_ATHILA_complete_2.004ac7e6.jpg";